import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgCartPaymentComponent } from '@app/shared/components/svg/cart/svg-cart-payment.component';

@NgModule({
  imports: [CommonModule],
  declarations: [SvgCartPaymentComponent],
  exports: [SvgCartPaymentComponent]
})
export class SvgCartModule {}
